import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  breakModalOpened: false,
  breakModalMode: '',
  cancelModalOpened: false,
  cancellationQuote: {
    loading: false,
    ready: false,
    price: null,
    cost: null,
  },
};

// Actions
const SET_OPENED_BREAK_MODAL = 'shipper-order-edit/SET_OPENED_BREAK_MODAL';
const SET_OPENED_CANCEL_MODAL = 'shipper-order-edit/SET_OPENED_CANCEL_MODAL';
const SET_CANCELLATION_QUOTE = 'shipper-order-edit/SET_CANCELLATION_QUOTE';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_OPENED_BREAK_MODAL](state, payload) {
    return {
      ...state,
      breakModalOpened: !!payload,
      breakModalMode: payload ? payload : '',
    };
  },
  [SET_OPENED_CANCEL_MODAL](state, payload) {
    return {
      ...state,
      cancelModalOpened: payload,
    };
  },
  [SET_CANCELLATION_QUOTE](state, payload) {
    return {
      ...state,
      cancellationQuote: {
        ...state.cancellationQuote,
        ...payload,
      },
    };
  },
});

// Action creators
export const setOpenedBreakModal = (payload) => ({
  type: SET_OPENED_BREAK_MODAL,
  payload: payload,
});

export const setOpenedCancelModal = (payload) => ({
  type: SET_OPENED_CANCEL_MODAL,
  payload: payload,
});

export const setCancellationQuote = (payload) => ({
  type: SET_CANCELLATION_QUOTE,
  payload: payload,
});
